import { render, staticRenderFns } from "./TokenDeployer.vue?vue&type=template&id=6275bfa8&"
import script from "./TokenDeployer.vue?vue&type=script&lang=js&"
export * from "./TokenDeployer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports